module.exports = __webpack_public_path__ + "img/yw_3.ddce3626.png";